'use client';

import React, { ComponentProps, RefObject, useRef } from 'react';

import clsx from 'clsx';

import { useSlideOverflowX } from './useSlideOverflowX';

const ScrollableWrapper = ({
    children,
    className,
    ...props
}: ComponentProps<'div'>) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const { onMouseLeaving, onMouseDown, onMouseMove } = useSlideOverflowX(
        containerRef as RefObject<HTMLDivElement>,
    );

    return (
        <div
            className={clsx(
                'no-scrollbar flex overflow-x-auto snap-mandatory snap-x scroll-pl-4 gap-4 [&>*]:-scroll-ml-4 [&>*]:snap-start [&>*]:shrink-0 z-1',
                className,
            )}
            ref={containerRef}
            {...{
                onMouseLeave: onMouseLeaving,
                onMouseUp: onMouseLeaving,
                onMouseMove,
                onMouseDown,
            }}
            {...props}
        >
            {children}
        </div>
    );
};

export default ScrollableWrapper;
